import { useNavigate, useParams } from 'react-router-dom'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'

import { EditGroup } from 'modules/expenses/components/groups/Edit'
import { useGroupDetail } from 'modules/expenses/hooks/useGroupDetail'
import { useExpensesNavigation } from 'modules/expenses/hooks/useExpensesNavigation'

const GroupEditPage = () => {
  const navigate = useNavigate()
  const { groupId } = useParams()
  const { navigation } = useExpensesNavigation()

  const { group, loading } = useGroupDetail({ id: String(groupId), includeAttachments: true })

  if (loading) return <Loading inline />
  if (!group) return <NotFound />

  return (
    <EditGroup
      group={group}
      onClose={() => navigate(navigation.groups.id.fullPath({ groupId: String(groupId) }))}
    />
  )
}

export default GroupEditPage
